module.exports = __webpack_public_path__ + "media/img/home/clients-map/map2-e53496eda7ac024f3a8fbf93820638c8.png";